import React from "react";

const Footer = () => {
  return (
    <footer className="app-footer">
      <p>© {new Date().getFullYear()} EduSync AI · Learn Together. Grow Faster.</p>
    </footer>
  );
};

export default Footer;
